// // src/views/admin/Uncrawled/components/KeywordPad.jsx

// import {
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalFooter,
//   ModalBody,
//   ModalCloseButton,
//   Button,
//   Box,
//   Text,
//   VStack,
//   HStack,
//   Badge,
//   Checkbox,
//   useColorModeValue,
//   Tabs,
//   TabList,
//   Tab,
//   TabPanels,
//   TabPanel,
//   Flex,
//   Input,
//   IconButton,
//   Tooltip,
//   Spinner,
// } from "@chakra-ui/react";
// import React, { useState, useEffect } from "react";
// import { MdCheckCircle, MdOutlineCleaningServices, MdLabel, MdAdd, MdDelete } from "react-icons/md";
// import { useListContext } from "../../../../contexts/listContext";

// export default function KeywordPad({
//   isOpen,
//   onClose,
//   accumulatedKeywordsByStatus,
//   onApprove,
//   isLoading,
// }) {
//   const [selectedKeywords, setSelectedKeywords] = useState({});
//   const [activeStatusTab, setActiveStatusTab] = useState(0);
//   const [existingKeywords, setExistingKeywords] = useState({});
//   const [loadingExisting, setLoadingExisting] = useState(false);
//   const [manualKeywordInput, setManualKeywordInput] = useState({});
//   const [allKeywords, setAllKeywords] = useState({});

//   const textColor = useColorModeValue("secondaryGray.900", "white");
//   const secondaryText = useColorModeValue("gray.600", "gray.400");
//   const cardBg = useColorModeValue("white", "navy.800");
//   const sectionBg = useColorModeValue("gray.50", "whiteAlpha.50");
//   const borderColor = useColorModeValue("gray.200", "whiteAlpha.200");
//   const aiSuggestionBg = useColorModeValue("purple.50", "purple.900");
//   const existingBg = useColorModeValue("orange.50", "orange.900");
//   const manualBg = useColorModeValue("green.50", "green.900");

//   const { list: keywordsList } = useListContext();

//   const getKeywordName = (keyword_id) => {
//     if (!keywordsList || keywordsList.length === 0) return `ID: ${keyword_id}`;
//     const keyword = keywordsList.find((kw) => kw.id == keyword_id);
//     return keyword ? keyword.name : `ID: ${keyword_id}`;
//   };

//   const getStatusLabel = (status) => (status === "X" ? "Negative" : "Positive");
//   const getStatusColor = (status) => (status === "X" ? "red" : "brand");

//   // Initialize and fetch data
//   useEffect(() => {
//     if (isOpen && accumulatedKeywordsByStatus) {
//       const initialized = {};
//       const inputInit = {};
//       const combined = {};

//       for (const status in accumulatedKeywordsByStatus) {
//         combined[status] = {};
//         for (const keyword_id in accumulatedKeywordsByStatus[status]) {
//           const key = `${status}-${keyword_id}`;
//           initialized[key] = [];
//           inputInit[key] = "";

//           combined[status][keyword_id] = {
//             ai: {
//               brand: accumulatedKeywordsByStatus[status][keyword_id]?.brand || [],
//               compound: accumulatedKeywordsByStatus[status][keyword_id]?.compound || []
//             },
//             existing: { brand: [], compound: [] },
//             manual: []
//           };
//         }
//       }

//       setSelectedKeywords(initialized);
//       setManualKeywordInput(inputInit);
//       setAllKeywords(combined);
//       setActiveStatusTab(0);
//       fetchExistingKeywords();
//     }
//   }, [isOpen, accumulatedKeywordsByStatus]);

//   const fetchExistingKeywords = async () => {
//     try {
//       setLoadingExisting(true);

//       if (!accumulatedKeywordsByStatus) return;

//       const statusArray = Object.keys(accumulatedKeywordsByStatus);

//       for (const status of statusArray) {
//         const keyword_ids = Object.keys(accumulatedKeywordsByStatus[status]).map(id => parseInt(id));

//         if (keyword_ids.length === 0) continue;

//         const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'}/api/products/getExistingKeywords`, {
//           method: "POST",
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
//             keyword_ids: keyword_ids,
//             status: status
//           })
//         });

//         if (response.ok) {
//           const result = await response.json();
//           if (result.success) {
//             setExistingKeywords(prev => ({
//               ...prev,
//               [status]: result.data
//             }));

//             // Merge existing keywords into allKeywords
//             setAllKeywords(prev => {
//               const updated = { ...prev };
//               for (const kw_id in result.data) {
//                 const notepadKeywords = result.data[kw_id]?.notepad || [];
//                 if (updated[status] && updated[status][kw_id]) {
//                   updated[status][kw_id].existing = {
//                     brand: [],
//                     compound: notepadKeywords
//                   };
//                 }
//               }
//               return updated;
//             });
//           }
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching existing keywords:", err);
//     } finally {
//       setLoadingExisting(false);
//     }
//   };

//   const handleToggleKeyword = (status, keyword_id, keyword, source) => {
//     const key = `${status}-${keyword_id}`;
//     setSelectedKeywords((prev) => {
//       const updated = { ...prev };
//       if (!updated[key]) updated[key] = [];
//       updated[key] = updated[key].includes(keyword)
//         ? updated[key].filter((k) => k !== keyword)
//         : [...updated[key], keyword];
//       return updated;
//     });
//   };

//   const handleAddManualKeyword = (status, keyword_id) => {
//     const key = `${status}-${keyword_id}`;
//     const inputValue = manualKeywordInput[key]?.trim();

//     if (!inputValue) {
//       alert("Please enter a keyword");
//       return;
//     }

//     setAllKeywords(prev => {
//       const updated = { ...prev };
//       if (!updated[status][keyword_id].manual) {
//         updated[status][keyword_id].manual = [];
//       }

//       // Check for duplicates across all sources
//       const exists = [
//         ...updated[status][keyword_id].ai.brand,
//         ...updated[status][keyword_id].ai.compound,
//         ...updated[status][keyword_id].existing.brand,
//         ...updated[status][keyword_id].existing.compound,
//         ...updated[status][keyword_id].manual
//       ].some(k => k.toLowerCase() === inputValue.toLowerCase());

//       if (exists) {
//         alert("This keyword already exists!");
//         return prev;
//       }

//       updated[status][keyword_id].manual.push(inputValue);
//       return updated;
//     });

//     setManualKeywordInput(prev => ({
//       ...prev,
//       [key]: ""
//     }));
//   };

//   const handleDeleteKeyword = (status, keyword_id, keyword, source) => {
//     setAllKeywords(prev => {
//       const updated = { ...prev };
//       if (source === 'ai') {
//         updated[status][keyword_id].ai.brand = updated[status][keyword_id].ai.brand.filter(k => k !== keyword);
//         updated[status][keyword_id].ai.compound = updated[status][keyword_id].ai.compound.filter(k => k !== keyword);
//       } else if (source === 'existing') {
//         updated[status][keyword_id].existing.brand = updated[status][keyword_id].existing.brand.filter(k => k !== keyword);
//         updated[status][keyword_id].existing.compound = updated[status][keyword_id].existing.compound.filter(k => k !== keyword);
//       } else if (source === 'manual') {
//         updated[status][keyword_id].manual = updated[status][keyword_id].manual.filter(k => k !== keyword);
//       }

//       // Also remove from selected if it was selected
//       const key = `${status}-${keyword_id}`;
//       setSelectedKeywords(prevSelected => ({
//         ...prevSelected,
//         [key]: (prevSelected[key] || []).filter(k => k !== keyword)
//       }));

//       return updated;
//     });
//   };

//   const handleApprove = () => {
//     const statusArray = ["A", "X"];
//     const currentStatus = statusArray[activeStatusTab];

//     const selectedByStatus = {};
//     for (const keyword_id in allKeywords[currentStatus]) {
//       const key = `${currentStatus}-${keyword_id}`;
//       if (selectedKeywords[key]?.length > 0) {
//         selectedByStatus[keyword_id] = selectedKeywords[key];
//       }
//     }

//     if (Object.keys(selectedByStatus).length === 0) {
//       alert("Please select at least one keyword to save");
//       return;
//     }

//     onApprove(selectedByStatus, currentStatus);
//   };

//   if (!accumulatedKeywordsByStatus || Object.keys(accumulatedKeywordsByStatus).length === 0) return null;

//   const statusArray = ["A", "X"];

//   return (
//     <Modal isOpen={isOpen} onClose={onClose} size="3xl" scrollBehavior="inside">
//       <ModalOverlay backdropFilter="blur(4px)" />
//       <ModalContent borderRadius="20px" bg={cardBg} maxH="90vh">
//         <ModalHeader borderBottom="1px solid" borderColor={borderColor} p="20px">
//           <Flex align="center" justify="space-between" pr="30px">
//             <HStack>
//               <Box p="8px" bg="brand.500" borderRadius="10px">
//                 <MdLabel color="white" />
//               </Box>
//               <VStack align="start" spacing="0">
//                 <Text fontSize="lg" fontWeight="700" color={textColor}>
//                   Keyword Notepad
//                 </Text>
//                 <Text fontSize="xs" color={secondaryText} fontWeight="500">
//                   Review, select, and manage keyword filters
//                 </Text>
//               </VStack>
//             </HStack>
//           </Flex>
//         </ModalHeader>
//         <ModalCloseButton top="20px" />

//         {loadingExisting && (
//           <Flex justify="center" align="center" p="20px">
//             <Spinner mr="10px" />
//             <Text>Loading existing keywords...</Text>
//           </Flex>
//         )}

//         {!loadingExisting && (
//           <ModalBody p="0">
//             <Tabs
//               variant="unstyled"
//               index={activeStatusTab}
//               onChange={setActiveStatusTab}
//               display="flex"
//               flexDirection="column"
//               h="100%"
//             >
//               <TabList px="20px" py="10px" borderBottom="1px solid" borderColor={borderColor} gap="10px">
//                 {statusArray.map((status) => (
//                   <Tab
//                     key={status}
//                     _selected={{ bg: `${getStatusColor(status)}.500`, color: "white" }}
//                     bg={sectionBg}
//                     borderRadius="10px"
//                     fontSize="sm"
//                     fontWeight="600"
//                     px="20px"
//                     transition="0.2s"
//                   >
//                     {getStatusLabel(status)}
//                   </Tab>
//                 ))}
//               </TabList>

//               <TabPanels flex="1" overflowY="auto">
//                 {statusArray.map((status) => {
//                   const keywordsData = allKeywords[status] || {};

//                   return (
//                     <TabPanel key={status} p="20px">
//                       <VStack align="stretch" spacing="20px">
//                         {Object.keys(keywordsData).length === 0 ? (
//                           <Text fontSize="sm" color={secondaryText} textAlign="center" py="40px">
//                             No keywords for {getStatusLabel(status)}
//                           </Text>
//                         ) : (
//                           Object.keys(keywordsData).map((kwId) => {
//                             const data = keywordsData[kwId];
//                             const key = `${status}-${kwId}`;
//                             const selectedCount = selectedKeywords[key]?.length || 0;
//                             const totalCount = 
//                               (data.ai?.brand?.length || 0) + 
//                               (data.ai?.compound?.length || 0) + 
//                               (data.existing?.brand?.length || 0) + 
//                               (data.existing?.compound?.length || 0) + 
//                               (data.manual?.length || 0);

//                             return (
//                               <Box key={kwId} border="1px solid" borderColor={borderColor} borderRadius="16px" overflow="hidden">
//                                 {/* Header */}
//                                 <Flex justify="space-between" align="center" bg={sectionBg} p="12px 16px" borderBottom="1px solid" borderColor={borderColor}>
//                                   <Text fontWeight="700" color={textColor} fontSize="sm">
//                                     {getKeywordName(kwId)}
//                                   </Text>
//                                   <Badge colorScheme={selectedCount > 0 ? "green" : "gray"} variant="flat" borderRadius="6px">
//                                     {selectedCount} / {totalCount} Selected
//                                   </Badge>
//                                 </Flex>

//                                 {/* Body */}
//                                 <Box p="16px">
//                                   <VStack align="stretch" spacing={4}>
//                                     {/* AI SUGGESTIONS */}
//                                     {((data.ai?.brand?.length || 0) + (data.ai?.compound?.length || 0)) > 0 && (
//                                       <Box bg={aiSuggestionBg} p="12px" borderRadius="12px">
//                                         <Text fontSize="xs" fontWeight="bold" color="purple.600" mb="8px" textTransform="uppercase">
//                                           ✨ New Generated
//                                         </Text>
//                                         <Flex wrap="wrap" gap={2}>
//                                           {[...(data.ai?.brand || []), ...(data.ai?.compound || [])].map((k) => (
//                                             <SelectableKeywordBadge
//                                               key={k}
//                                               label={k}
//                                               isSelected={selectedKeywords[key]?.includes(k)}
//                                               onToggle={() => handleToggleKeyword(status, kwId, k, 'ai')}
//                                               onDelete={() => handleDeleteKeyword(status, kwId, k, 'ai')}
//                                               source="ai"
//                                             />
//                                           ))}
//                                         </Flex>
//                                       </Box>
//                                     )}

//                                     {/* EXISTING/PENDING KEYWORDS */}
//                                     {((data.existing?.brand?.length || 0) + (data.existing?.compound?.length || 0)) > 0 && (
//                                       <Box bg={existingBg} p="12px" borderRadius="12px">
//                                         <Text fontSize="xs" fontWeight="bold" color="orange.600" mb="8px" textTransform="uppercase">
//                                           📝 Pending Approval
//                                         </Text>
//                                         <Flex wrap="wrap" gap={2}>
//                                           {[...(data.existing?.brand || []), ...(data.existing?.compound || [])].map((k) => (
//                                             <SelectableKeywordBadge
//                                               key={k}
//                                               label={k}
//                                               isSelected={selectedKeywords[key]?.includes(k)}
//                                               onToggle={() => handleToggleKeyword(status, kwId, k, 'existing')}
//                                               onDelete={() => handleDeleteKeyword(status, kwId, k, 'existing')}
//                                               source="existing"
//                                             />
//                                           ))}
//                                         </Flex>
//                                       </Box>
//                                     )}

//                                     {/* MANUAL KEYWORDS */}
//                                     {(data.manual?.length || 0) > 0 && (
//                                       <Box bg={manualBg} p="12px" borderRadius="12px">
//                                         <Text fontSize="xs" fontWeight="bold" color="green.600" mb="8px" textTransform="uppercase">
//                                           ➕ Manually Added
//                                         </Text>
//                                         <Flex wrap="wrap" gap={2}>
//                                           {(data.manual || []).map((k) => (
//                                             <SelectableKeywordBadge
//                                               key={k}
//                                               label={k}
//                                               isSelected={selectedKeywords[key]?.includes(k)}
//                                               onToggle={() => handleToggleKeyword(status, kwId, k, 'manual')}
//                                               onDelete={() => handleDeleteKeyword(status, kwId, k, 'manual')}
//                                               source="manual"
//                                             />
//                                           ))}
//                                         </Flex>
//                                       </Box>
//                                     )}

//                                     {/* ADD MANUAL KEYWORD */}
//                                     <HStack spacing={2}>
//                                       <Input
//                                         placeholder="Add keyword manually..."
//                                         size="sm"
//                                         value={manualKeywordInput[key] || ""}
//                                         onChange={(e) => setManualKeywordInput(prev => ({
//                                           ...prev,
//                                           [key]: e.target.value
//                                         }))}
//                                         onKeyPress={(e) => {
//                                           if (e.key === 'Enter') {
//                                             handleAddManualKeyword(status, kwId);
//                                           }
//                                         }}
//                                         borderRadius="8px"
//                                       />
//                                       <Tooltip label="Add keyword (Enter)" placement="top">
//                                         <IconButton
//                                           icon={<MdAdd />}
//                                           size="sm"
//                                           colorScheme="blue"
//                                           onClick={() => handleAddManualKeyword(status, kwId)}
//                                           borderRadius="8px"
//                                         />
//                                       </Tooltip>
//                                     </HStack>
//                                   </VStack>
//                                 </Box>
//                               </Box>
//                             );
//                           })
//                         )}
//                       </VStack>
//                     </TabPanel>
//                   );
//                 })}
//               </TabPanels>
//             </Tabs>
//           </ModalBody>
//         )}

//         <ModalFooter borderTop="1px solid" borderColor={borderColor} p="20px">
//           <Button variant="outline" mr="auto" leftIcon={<MdOutlineCleaningServices />} onClick={onClose} colorScheme="red">
//             Cancel
//           </Button>
//           <Button
//             colorScheme="green"
//             variant="solid"
//             leftIcon={<MdCheckCircle />}
//             onClick={handleApprove}
//             isLoading={isLoading}
//             borderRadius="12px"
//             px="25px"
//           >
//             Confirm & Save
//           </Button>
//         </ModalFooter>
//       </ModalContent>
//     </Modal>
//   );
// }

// function SelectableKeywordBadge({ label, isSelected, onToggle, onDelete, source = "ai" }) {
//   const activeBg = useColorModeValue("brand.50", "brand.900");
//   const activeColor = useColorModeValue("brand.600", "brand.200");
//   const activeBorder = useColorModeValue("brand.200", "brand.700");
//   const inactiveBg = useColorModeValue("white", "gray.800");
//   const inactiveBorder = useColorModeValue("gray.200", "gray.600");

//   return (
//     <HStack
//       spacing={1}
//       bg={isSelected ? activeBg : inactiveBg}
//       color={isSelected ? activeColor : "inherit"}
//       border="1px solid"
//       borderColor={isSelected ? activeBorder : inactiveBorder}
//       px="8px"
//       py="5px"
//       borderRadius="8px"
//       transition="all 0.2s"
//       _hover={{ transform: "translateY(-1px)", boxShadow: "sm" }}
//     >
//       <Checkbox 
//         isChecked={isSelected}
//         onChange={onToggle}
//         size="sm"
//         colorScheme="brand"
//         pointerEvents="auto"
//       />
//       <Text fontSize="sm" fontWeight="600" flex="1">
//         {label}
//       </Text>
//       <Tooltip label="Delete keyword" placement="top">
//         <IconButton
//           icon={<MdDelete />}
//           size="xs"
//           variant="ghost"
//           colorScheme="red"
//           onClick={onDelete}
//           _hover={{ bg: "red.200" }}
//           aria-label="delete"
//         />
//       </Tooltip>
//     </HStack>
//   );
// }


// src/views/admin/Uncrawled/components/KeywordPad.jsx

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Text,
  VStack,
  HStack,
  Badge,
  Checkbox,
  useColorModeValue,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Flex,
  Input,
  IconButton,
  Tooltip,
  Spinner,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import {
  MdCheckCircle,
  MdOutlineCleaningServices,
  MdLabel,
  MdAdd,
  MdDelete,
} from "react-icons/md";
import { useListContext } from "../../../../contexts/listContext";

export default function KeywordPad({
  isOpen,
  onClose,
  accumulatedKeywordsByStatus,
  onApprove,
  isLoading,
  onDelete
}) {
  const [selectedKeywords, setSelectedKeywords] = useState({});
  const [activeStatusTab, setActiveStatusTab] = useState(0);
  const [loadingExisting, setLoadingExisting] = useState(false);
  const [manualKeywordInput, setManualKeywordInput] = useState({});
  const [allKeywords, setAllKeywords] = useState({"X":{} ,"A":{}});

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const secondaryText = useColorModeValue("gray.600", "gray.400");
  const cardBg = useColorModeValue("white", "navy.800");
  const sectionBg = useColorModeValue("gray.50", "whiteAlpha.50");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.200");
  const backendUrl = process.env.REACT_APP_BACKEND_URL
  const { keywordsList, list } = useListContext();



  const statusArray = ["A", "X"];

  const getKeywordName = (keyword_id) => {
    const keyword = list?.find((kw) => kw.id == keyword_id);
    return keyword ? keyword.name : `ID: ${keyword_id}`;
  };

  const getStatusLabel = (status) =>
    status === "X" ? "Negative" : "Positive";

  const getStatusColor = (status) =>
    status === "X" ? "red" : "brand";

  const getCombinedKeywords = (data) => {
    // If data is undefined, return empty array immediately
    if (!data) return [];

    const all = [
      ...(data.ai?.brand || []),
      ...(data.ai?.compound || []),
      ...(data.existing?.brand || []),
      ...(data.existing?.compound || []),
      ...(data.manual || []),
    ];

    const uniqueMap = new Map();
    all.forEach((k) => {
      if (k) uniqueMap.set(k.toLowerCase(), k);
    });
    return Array.from(uniqueMap.values());
  };


  useEffect(() => {
    if (!isOpen) return;

    const combined = { A: {}, X: {} }; // Initialize both statuses
    const selectedInit = {};
    const inputInit = {};


    // Collect all keyword IDs from BOTH accumulatedKeywordsByStatus AND keywordsList
    const allKeywordIds = new Set();
    
    // First, add IDs from accumulatedKeywordsByStatus
    statusArray.forEach((status) => {
      const statusData = accumulatedKeywordsByStatus?.[status] || {};
      Object.keys(statusData).forEach((kwId) => {
        allKeywordIds.add(String(kwId));
      });
    });

    // Then add IDs from keywordsList (handle both object and ID cases)
    if (keywordsList && Array.isArray(keywordsList)) {
      keywordsList.forEach((kw) => {
        const id = kw?.id || kw; // Handle both {id: 1} and raw 1
        if (id) allKeywordIds.add(String(id));
      });
    }


    // Now initialize with ALL keyword IDs
    statusArray.forEach((status) => {
      const statusData = accumulatedKeywordsByStatus?.[status] || {};

      allKeywordIds.forEach((kwId) => {
        combined[status][kwId] = {
          ai: {
            brand: statusData[kwId]?.ai?.brand || statusData[kwId]?.brand || [],
            compound: statusData[kwId]?.ai?.compound || statusData[kwId]?.compound || [],
          },
          existing: { brand: [], compound: [] },
          manual: [],
        };

        const key = `${status}-${kwId}`;
        selectedInit[key] = [];
        inputInit[key] = "";
      });
    });

    setAllKeywords(combined);
    setSelectedKeywords(selectedInit);
    setManualKeywordInput(inputInit);

    fetchExistingKeywords();
  }, [isOpen, accumulatedKeywordsByStatus, keywordsList]);

  const fetchExistingKeywords = async () => {
    try {
      setLoadingExisting(true);
      const keyword_ids = keywordsList;

      if (!keyword_ids.length) return;

      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/products/getExistingKeywords`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            keyword_ids
          }),
        }
      );

      const result = await res.json();
      if (!result.success || !result.data) return;

      setAllKeywords((prev) => {
        const updated = { ...prev };

        // result.data looks like: {"1": {"X": ["la-shield"], "A": []}, ...}
        Object.keys(result.data).forEach((kwId) => {
          const item = result.data[kwId];
          const strKwId = String(kwId); // Ensure string consistency

          // Update Positive Tab (A)
          if (updated["A"] && updated["A"][strKwId]) {
            updated["A"][strKwId].existing.compound = item.A || [];
          }

          // Update Negative Tab (X)
          if (updated["X"] && updated["X"][strKwId]) {
            updated["X"][strKwId].existing.compound = item.X || [];
          }
        });
        return updated;
      });
    } catch (e) {
      console.error("Fetch Error:", e);
    } finally {
      setLoadingExisting(false);
    }
  };

  const handleToggleKeyword = (status, keyword_id, keyword) => {
    const key = `${status}-${keyword_id}`;
    setSelectedKeywords((prev) => ({
      ...prev,
      [key]: prev[key]?.includes(keyword)
        ? prev[key].filter((k) => k !== keyword)
        : [...(prev[key] || []), keyword],
    }));
  };

const handleAddManualKeyword = async (status, keyword_id) => {
  const key = `${status}-${keyword_id}`;
  const value = manualKeywordInput[key]?.trim();

  if (!value) return alert("Enter a keyword");

  // 1. Get the current brand data from state
  const currentBrandData = allKeywords[status]?.[keyword_id];
  if (!currentBrandData) return;

  // 2. Check for duplicates before proceeding
  const exists = getCombinedKeywords(currentBrandData).some(
    (k) => k.toLowerCase() === value.toLowerCase()
  );
  if (exists) return alert("Keyword already exists");

  try {
    // 3. Create the updated data structure locally
    const updatedData = {
      ...currentBrandData,
      manual: [...(currentBrandData.manual || []), value],
    };

    // 4. Calculate the flat list for the API call
    const finalKeywordsArray = normalizeKeywordsForSave(updatedData);
    const keywordsString = finalKeywordsArray.join(",");

    // 5. Update UI State
    setAllKeywords((prev) => ({
      ...prev,
      [status]: {
        ...prev[status],
        [keyword_id]: updatedData,
      },
    }));

    // Clear the input field
    setManualKeywordInput((prev) => ({ ...prev, [key]: "" }));

    // 6. PERSIST TO BACKEND
    console.log(`Adding keyword to backend for ${keyword_id}:`, keywordsString);
    
    const response = await fetch(`${backendUrl}/api/keyword/updateNotepadCheckKeywords`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        keyword_id,
        status,
        keywords: keywordsString,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to save the new keyword to the server");
    }

    console.log("Keyword added and saved successfully");

  } catch (err) {
    console.error("Error adding manual keyword:", err);
    alert("Could not save keyword to database.");
  }
};



  const normalizeKeywordsForSave = (keywordData) => {
    if (!keywordData) return [];
    const all = [
      ...(keywordData.ai?.brand || []),
      ...(keywordData.ai?.compound || []),
      ...(keywordData.existing?.brand || []),
      ...(keywordData.existing?.compound || []),
      ...(keywordData.manual || []),
    ];
    // Dedupe using a Map
    const map = new Map();
    all.forEach(k => {
      if (k && typeof k === 'string') map.set(k.toLowerCase(), k);
    });
    return Array.from(map.values());
  };


  const handleDeleteKeyword = async (status, keyword_id, keyword) => {
    console.log("Delete initiated for:", keyword);

    // STEP 1: Get a snapshot of the current data from state
    const currentStatusData = allKeywords[status];
    if (!currentStatusData || !currentStatusData[keyword_id]) {
      console.error("Could not find keyword data in state");
      return;
    }

    const brandData = currentStatusData[keyword_id];

    // STEP 2: Calculate the NEW data locally (Independent of State)
    // This ensures we have the data ready for the API call immediately
    const updatedBrandData = {
      ...brandData,
      ai: {
        brand: (brandData.ai?.brand || []).filter(k => k !== keyword),
        compound: (brandData.ai?.compound || []).filter(k => k !== keyword),
      },
      existing: {
        brand: (brandData.existing?.brand || []).filter(k => k !== keyword),
        compound: (brandData.existing?.compound || []).filter(k => k !== keyword),
      },
      manual: (brandData.manual || []).filter(k => k !== keyword),
    };

    // STEP 3: Create the string for the database call
    const finalKeywordsArray = normalizeKeywordsForSave(updatedBrandData);
    const keywordsString = finalKeywordsArray.join(",");

    // STEP 4: Update UI state (This happens in the background)
    setAllKeywords((prev) => ({
      ...prev,
      [status]: {
        ...prev[status],
        [keyword_id]: updatedBrandData,
      },
    }));

    const key = `${status}-${keyword_id}`;
    setSelectedKeywords((prevSel) => ({
      ...prevSel,
      [key]: (prevSel[key] || []).filter((k) => k !== keyword),
    }));

    // STEP 5: Notify Parent (wrapped in try/catch to prevent parent errors from stopping the API)
    try {
      if (onDelete) onDelete(status, keyword_id, keyword);
    } catch (e) {
      console.warn("Parent onDelete error:", e);
    }

    // STEP 6: THE API CALL
    // We use the 'keywordsString' we calculated in Step 3
    try {
      console.log("Calling endpoint with:", keywordsString);
      const response = await fetch(`${backendUrl}/api/keyword/updateNotepadCheckKeywords`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          keyword_id,
          status,
          keywords: keywordsString,
        }),
      });

      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }
      console.log("Backend updated successfully");
    } catch (e) {
      console.error("THE API CALL FAILED:", e);
    }
  };

  const handleApprove = () => {
    const status = statusArray[activeStatusTab];
    const payload = {};

    for (const kwId in allKeywords[status]) {
      const key = `${status}-${kwId}`;
      if (selectedKeywords[key]?.length) {
        payload[kwId] = selectedKeywords[key];
      }
    }

    if (!Object.keys(payload).length)
      return alert("Select at least one keyword");

    onApprove(payload, status);
  };

  if (!accumulatedKeywordsByStatus) return null;

  const handleToggleSelectAll = (status, keyword_id) => {
    const key = `${status}-${keyword_id}`;
    const combined = getCombinedKeywords(allKeywords[status][keyword_id]);

    setSelectedKeywords((prev) => {
      const allSelected =
        prev[key]?.length === combined.length;

      return {
        ...prev,
        [key]: allSelected ? [] : [...combined],
      };
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg={cardBg} borderRadius="20px">
        <ModalHeader borderBottom="1px solid" borderColor={borderColor}>
          <HStack>
            <Box p="8px" bg="brand.500" borderRadius="10px">
              <MdLabel color="white" />
            </Box>
            <Text fontWeight="700">Keyword Notepad</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />

        {loadingExisting ? (
          <Flex justify="center" p="20px">
            <Spinner />
          </Flex>
        ) : (
          <ModalBody>
            <Tabs index={activeStatusTab} onChange={setActiveStatusTab}>
              <TabList py="10px" gap="10px">
                {statusArray.map((status) => (
                  <Tab
                    key={status}
                    _selected={{ bg: `${getStatusColor(status)}.500`, color: "white" }}
                    bg={sectionBg}
                    borderRadius="10px"
                    fontSize="sm"
                    fontWeight="600"
                    px="20px"
                    transition="0.2s"
                  >
                    {getStatusLabel(status)}
                  </Tab>
                ))}
              </TabList>

              <TabPanels>
                {statusArray.map((status) => (
                  <TabPanel key={status}>
                    <VStack spacing={4} align="stretch">
                      {Object.keys(allKeywords[status] || {}).length > 0 ? (
                        Object.keys(allKeywords[status]).map((kwId) => {
                          const data = allKeywords[status][kwId];
                          const key = `${status}-${kwId}`;
                          const combined = getCombinedKeywords(data);
                          if (combined.length === 0) return null;
                          return (
                            <Box
                              key={kwId}
                              border="1px solid"
                              borderColor={borderColor}
                              borderRadius="12px"
                            >
                              <Flex
                                justify="space-between"
                                align="center"
                                bg={sectionBg}
                                p="10px"
                              >
                                <Text fontWeight="600">
                                  {getKeywordName(kwId)}
                                </Text>

                                <HStack spacing={3}>
                                  <Badge>
                                    {selectedKeywords[key]?.length || 0} / {combined.length} Selected
                                  </Badge>

                                  <Button
                                    size="xs"
                                    variant="outline"
                                    onClick={() => handleToggleSelectAll(status, kwId)}
                                  >
                                    {selectedKeywords[key]?.length === combined.length
                                      ? "Clear All"
                                      : "Select All"}
                                  </Button>
                                </HStack>

                              </Flex>

                              <Box p="12px">
                                <Flex wrap="wrap" gap={2}>
                                  {combined.map((k) => (
                                    <SelectableKeywordBadge
                                      key={k}
                                      label={k}
                                      isSelected={selectedKeywords[key]?.includes(
                                        k
                                      )}
                                      onToggle={() =>
                                        handleToggleKeyword(status, kwId, k)
                                      }
                                      onDelete={() =>
                                        handleDeleteKeyword(status, kwId, k)
                                      }
                                    />
                                  ))}
                                </Flex>

                                <HStack mt="10px">
                                  <Input
                                    size="sm"
                                    placeholder="Add keyword..."
                                    value={manualKeywordInput[key] || ""}
                                    onChange={(e) =>
                                      setManualKeywordInput((p) => ({
                                        ...p,
                                        [key]: e.target.value,
                                      }))
                                    }
                                    onKeyDown={(e) =>
                                      e.key === "Enter" &&
                                      handleAddManualKeyword(status, kwId)
                                    }
                                  />
                                  <IconButton
                                    size="sm"
                                    icon={<MdAdd />}
                                    onClick={() =>
                                      handleAddManualKeyword(status, kwId)
                                    }
                                  />
                                </HStack>
                              </Box>
                            </Box>
                          );
                        })) : (<h1>No Keywords</h1>)}
                    </VStack>
                  </TabPanel>
                ))}
              </TabPanels>
            </Tabs>
          </ModalBody>
        )}

        <ModalFooter>
          <Button
            variant="outline"
            colorScheme="red"
            mr="auto"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            colorScheme="green"
            leftIcon={<MdCheckCircle />}
            onClick={handleApprove}
            isLoading={isLoading}
          >
            Confirm & Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal >
  );
}

function SelectableKeywordBadge({ label, isSelected, onToggle, onDelete }) {
  const bg = useColorModeValue("white", "gray.800");
  const activeBg = useColorModeValue("blue.50", "blue.900");
  const hoverBg = useColorModeValue("gray.100", "gray.700");
  const borderColor = useColorModeValue("gray.300", "gray.600");
  const activeBorderColor = useColorModeValue("blue.400", "blue.300");

  return (
    <HStack
      spacing="8px"
      px="10px"
      py="6px"
      borderRadius="full"
      cursor="pointer"
      userSelect="none"
      bg={isSelected ? activeBg : bg}
      border="1px solid"
      borderColor={isSelected ? activeBorderColor : borderColor}
      _hover={{ bg: isSelected ? activeBg : hoverBg }}
      transition="all 0.15s ease"
      onClick={onToggle} // 🔥 click anywhere toggles
    >
      {/* Checkbox (visual only) */}
      <Checkbox
        size="sm"
        isChecked={isSelected}
        pointerEvents="none" // prevent double toggle
      />

      <Text
        fontSize="md"
        fontWeight={isSelected ? "600" : "400"}
        color={isSelected ? "blue.600" : "inherit"}
        whiteSpace="nowrap"
      >
        {label}
      </Text>

      {/* Delete button (stop click bubbling) */}
      <IconButton
        size="xs"
        icon={<MdDelete />}
        variant="ghost"
        colorScheme="red"
        aria-label="delete"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      />
    </HStack>
  );
}


